export default "__VITE_ASSET__DJSr3BZ6__"